import { Box, Stack, SxProps, Typography } from '@mui/material';
import { Button } from 'system/atoms';
import { useAuth } from '../hooks';
import { CognitoHostedUIIdentityProvider } from '../types';
import { GoogleIcon } from 'components/Icons/GoogleIcon';

const authLayoutStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: '100%'
};

const authContainerStyle: SxProps = {
  width: '547px',
  padding: '50px'
};

const authTitleStyle: SxProps = {
  fontSize: '36px',
  fontWeight: 400,
  color: 'primary.main'
};

const authContentStyle: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  mt: '48px'
};

const federatedSignInButtonStyle = {
  width: '100%',
  border: '1px solid',
  borderColor: 'primary.main',
  gap: '12px',
  color: '#504955',
  py: '16px',
  fontWeight: 500,
  mt: '0px'
};

export const AuthLayout = ({
  title,
  children,
  isSubmitting
}: {
  title: string;
  children: React.ReactNode;
  isSubmitting: boolean;
}) => {
  const { federatedSignIn } = useAuth();
  return (
    <Box sx={authLayoutStyle}>
      <Box sx={authContainerStyle}>
        <Typography sx={authTitleStyle} variant="h1">
          {title}
        </Typography>
        <Box sx={authContentStyle}>
          {children}
          <Stack sx={{ width: '100%', p: 0 }} spacing={2}>
            <Button
              type="submit"
              variant="tertiary"
              sx={federatedSignInButtonStyle}
              disabled={isSubmitting}
              onClick={() => {
                federatedSignIn({
                  provider: CognitoHostedUIIdentityProvider.Google
                });
              }}
            >
              <GoogleIcon />
              Sign in with Google
            </Button>
            <Button
              type="submit"
              variant="tertiary"
              sx={federatedSignInButtonStyle}
              disabled={isSubmitting}
              onClick={() => {
                federatedSignIn({
                  provider: 'Auth0'
                });
              }}
            >
              Sign in with SSO
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
